import type { HTMLAttributes } from 'react'

type Status = 'idle' | 'active' | 'success' | 'warning' | 'error'

const dotClasses: Record<Status, string> = {
  idle: 'bg-steel/40 dark:bg-cream/15',
  active: 'bg-carolina-dark dark:bg-carolina animate-pulse',
  success: 'bg-green-400 shadow-[0_0_4px_rgba(74,222,128,0.5)]',
  warning: 'bg-yellow-dark dark:bg-yellow animate-pulse',
  error: 'bg-red-400 shadow-[0_0_4px_rgba(248,113,113,0.5)]',
}

const textClasses: Record<Status, string> = {
  idle: 'text-mist dark:text-cream/25',
  active: 'text-carolina-dark dark:text-carolina',
  success: 'text-green-400',
  warning: 'text-yellow-dark dark:text-yellow',
  error: 'text-red-400',
}

type StatusDotProps = {
  status?: Status
  label?: string
} & HTMLAttributes<HTMLDivElement>

export function StatusDot({
  status = 'idle',
  label,
  className = '',
  ...props
}: StatusDotProps) {
  return (
    <div
      data-component="StatusDot"
      className={`flex items-center gap-2 ${className}`}
      {...props}
    >
      <span
        aria-label={label ?? status}
        className={`shrink-0 w-2.5 h-2.5 rounded-full ${dotClasses[status]}`}
      />
      {label && (
        <span
          className={`font-mono text-[12px] tracking-[1px] ${textClasses[status]}`}
        >
          {label}
        </span>
      )}
    </div>
  )
}
